// Duree (secondes) -> "2h01" a partir d'une heure, sinon "25min" ; les
// secondes sont ignorees (121'30" -> 2h01, 25'30" -> 25min). Utilise pour
// les listes de seances et le calendrier.
export function formaterDuree(secondes: number): string {
  const minutes = Math.floor(secondes / 60);
  const h = Math.floor(minutes / 60);
  return h > 0 ? `${h}h${String(minutes % 60).padStart(2, '0')}` : `${minutes}min`;
}

// Duree d'une competition : a la seconde sous l'heure (ex : 19'45", 42'08"),
// sinon comme formaterDuree (3h20).
export function formaterDureeCourse(secondes: number): string {
  if (secondes >= 3600) return formaterDuree(secondes);
  const total = Math.round(secondes);
  return `${Math.floor(total / 60)}'${String(total % 60).padStart(2, '0')}"`;
}
